<div>
  <h3>Viewing: {{ tripInfo.vehicle }}</h3>
  <p class="status">
    Status:
    @if (status.symbol === 1) {
      <mat-icon fontIcon="error" [style]="{ color: messageStatusColour }"></mat-icon>
    } @else if (status.symbol === 2) {
      <mat-icon fontIcon="schedule" [style]="{ color: messageStatusColour }"></mat-icon>
    } @else {
      <mat-icon fontIcon="check_circle" [style]="{ color: messageStatusColour }"></mat-icon>
    }
    <span [style]="{ color: messageStatusColour }">{{ status.message }}</span>
  </p>

  <div class="status-info">
    <div class="info-column">
      <div class="info"><b>Duty:&nbsp;</b> {{ tripInfo.duty ?? 'n/a' }}</div>
      <div class="info"><b>Route:&nbsp;</b> {{ tripInfo.route ?? 'n/a' }}</div>
      <div class="info"><b>Trip:&nbsp;</b> {{ tripInfo.trip ?? 'n/a' }}</div>
    </div>
    <div class="info-column">
      <div class="info"><b>Driver:&nbsp;</b> {{ tripInfo.driver ?? 'n/a' }}</div>
      <div class="info"><b>CP Time:&nbsp;</b> {{ tripInfo.cpTime ?? 'n/a' }}</div>
      <div class="info"><b>BDC Time:&nbsp;</b> {{ tripInfo.bdcTime ?? 'n/a' }}</div>
    </div>
  </div>

  <div class="status-icons">
    <button
      type="button"
      matButton="filled"
      (click)="cpColorDialog()"
      class="icons"
      [style]="{ 'background-color': getColourFromStatus('CP') }">
      <mat-icon fontIcon="podcasts" [style]="{ color: getSecondaryColour('CP') }"></mat-icon>
      @if (desktopSize()) {
        <p [style]="{ color: getSecondaryColour('CP') }">Cradlepoint Status</p>
      }
    </button>
    <button
      type="button"
      matButton="filled"
      (click)="bdcColorDialog()"
      class="icons"
      [style]="{ 'background-color': getColourFromStatus('BDC') }">
      <mat-icon fontIcon="directions_bus" [style]="{ color: getSecondaryColour('BDC') }"></mat-icon>
      @if (desktopSize()) {
        <p [style]="{ color: getSecondaryColour('BDC') }">Bus Status</p>
      }
    </button>
    <button
      type="button"
      matButton="filled"
      (click)="locationColorDialog()"
      class="icons"
      [style]="{ 'background-color': getColourFromStatus('Location') }">
      <mat-icon fontIcon="location_on" [style]="{ color: getSecondaryColour('Location') }"></mat-icon>
      @if (desktopSize()) {
        <p [style]="{ color: getSecondaryColour('Location') }">Vehicle GPS Status</p>
      }
    </button>
    @if (status.emvColour) {
      <button
        type="button"
        matButton="filled"
        (click)="emvColorDialog()"
        class="icons"
        [style]="{ 'background-color': getColourFromStatus('EMV') }">
        <mat-icon fontIcon="rss_feed" [style]="{ color: getSecondaryColour('EMV') }"></mat-icon>
        @if (desktopSize()) {
          <p [style]="{ color: getSecondaryColour('EMV') }">EMV Status</p>
        }
      </button>
    }
  </div>
</div>
